import { ReplaySubject, BehaviorSubject, Observable } from "rxjs";
import { YearAndMonth } from "../../services/activity.service";
import { map } from "rxjs/operators";

export class OverviewService {

    private readonly optionsAreInitializedSubject = new ReplaySubject<boolean>(1);

    readonly optionsAreInitialized = this.optionsAreInitializedSubject.asObservable();

    setOptionsAreInitialized(): void {
        this.optionsAreInitializedSubject.next(true);
    }


    private readonly workplaceIdSubject = new ReplaySubject<number>(1);

    readonly workplaceId = this.workplaceIdSubject.asObservable();

    changeWorkplaceId(workplaceId: number): void {
        this.workplaceIdSubject.next(workplaceId);
    }


    private readonly workGroupIdSubject = new ReplaySubject<number>(1);

    readonly workGroupId = this.workGroupIdSubject.asObservable();

    changeWorkGroupId(workGroupId: number): void {
        this.workGroupIdSubject.next(workGroupId);
    }


    private readonly yearAndMonthSubject = new ReplaySubject<YearAndMonth>(1);

    readonly yearAndMonth = this.yearAndMonthSubject.asObservable();

    changeYearAndMonth(yearAndMonth: YearAndMonth): void {
        this.yearAndMonthSubject.next(yearAndMonth);
    }


    private readonly filterTextSubject = new BehaviorSubject<string>(null);

    readonly filterText = this.filterTextSubject.asObservable();

    changeFilterText(filterText: string): void {
        this.filterTextSubject.next(filterText);
    }


    private readonly isProcessingSubject = new BehaviorSubject<number>(0);

    readonly isProcessing = this.isProcessingSubject.asObservable().pipe(
        map(processingCount => !!processingCount));

    changeIsProcessing(isProcessing: boolean): void {
        this.isProcessingSubject.next(this.isProcessingSubject.value + (isProcessing ? 1 : -1));
    }


    private readonly refreshSubject = new BehaviorSubject(null);

    readonly shouldRefresh = this.refreshSubject.asObservable();

    refresh(): void {
        this.refreshSubject.next(null);
    }


    private readonly personInfoSubject = new ReplaySubject<PersonInfo[]>(1);

    readonly personInfo = this.personInfoSubject.asObservable();

    registerPersonInfoStream(personInfoStream: Observable<PersonInfo[]>): void {
        personInfoStream.subscribe(this.personInfoSubject);
    }


    private readonly showBalanceSubject = new BehaviorSubject<boolean>(false);

    readonly showBalance = this.showBalanceSubject.asObservable();

    setShowBalance(show: boolean): void {
        this.showBalanceSubject.next(show);
    }


    private readonly showCrossWorkplaceBalanceSubject = new BehaviorSubject<boolean>(false);

    readonly showCrossWorkplaceBalance = this.showCrossWorkplaceBalanceSubject.asObservable();

    setShowCrossWorkplaceBalance(show: boolean): void {
        this.showCrossWorkplaceBalanceSubject.next(show);
    }
}

export interface PersonInfo {
    Id: number;
    Name: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/overview/overview.service.ts